export default function BagIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M17 4C17.3788 4 17.7251 4.214 17.8945 4.55279L19.8945 8.55279C19.9639 8.69164 20 8.84476 20 9V20C20 20.5523 19.5523 21 19 21H5.00049C4.4482 21 4.00049 20.5523 4.00049 20V9C4.00049 8.84479 4.03662 8.6917 4.10602 8.55287L6.10556 4.55287C6.27493 4.21404 6.62122 4 7.00003 4H17ZM17.3813 8L16.381 6H13.0003V8H17.3813ZM18 10H6.00003V19H18V10ZM6.61772 8L7.61803 6H11.0003V8H6.61772Z" fill="#333333" />
    </svg>
  );
}
